import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot } from "firebase/firestore";

export function useZones(env, client) {
  const [loadedZones, setLoadedZones] = useState(false);
  const [zones, setZones] = useState(null);

  useEffect(() => {
    setLoadedZones(false);
    if (!client) {
      setLoadedZones(true);
      return () => [];
    }
    let ref = collection(db, "kiosk", env, "client", client, "zones");
    
    // onSnapshot = reactivo + offline + cache
    const unsub = onSnapshot(ref, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setZones(data);
      setLoadedZones(true);
    });

    return () => unsub();
  }, [env, client]);

  return {loadedZones, zones};
}